<template>
	<div class="study-progress" style="width:100%;">
		<svg>
			<g class="bg">
				<rect width="100%"></rect>
			</g>
			<g class="markers">
				<line x1="0%" x2="0%" y1="20px" y2="30px"></line>
				<line x1="10%" x2="10%" y1="20px" y2="30px"></line>
				<line x1="20%" x2="20%" y1="20px" y2="30px"></line>
				<line x1="30%" x2="30%" y1="20px" y2="30px"></line>
				<line x1="40%" x2="40%" y1="20px" y2="30px"></line>
				<line x1="50%" x2="50%" y1="20px" y2="30px"></line>
				<line x1="60%" x2="60%" y1="20px" y2="30px"></line>
				<line x1="70%" x2="70%" y1="20px" y2="30px"></line>
				<line x1="80%" x2="80%" y1="20px" y2="30px"></line>
				<line x1="90%" x2="90%" y1="20px" y2="30px"></line>
				<line x1="100%" x2="100%" y1="20px" y2="30px"></line>
			</g>
			<g class="data">									
				<line :x1="startPercent + '%'" :x2="startPercent + '%'"  y1="20px"  y2="30px"></line>				
				<rect :x="startPercent + '%'" :width="(endPercent - startPercent) + '%'"></rect>
				<circle :cx="endPercent + '%'"></circle>
			</g>
		</svg>
	</div>
</template>

<script>

export default {
	props: {
		unitCount: { type: Number, default: 20 },
		startPercent: { type: Number, default: 0 },
		endPercent: { type: Number, default: 0 }
	},
	data() {
		return {
			
		}
	},
	methods: {
		
	}
}
</script>